import React from 'react';
import { LinkText } from 'views/components/molecules/LinkText';
import { Banner } from 'views/components/molecules/Banner';
import { SignUpForm } from 'views/components/organisms/SignUpForm';
import signUpImage from 'views/layouts/SignUpPageLayout/images/sign_up.png';
import { Spacer } from 'views/components/atoms/Spacer';
import { FormattedMessage } from 'react-intl';
import { localeIds } from 'locals';
import { ROUTER_PATH } from 'views/constants';
import { SignUpEmailForm } from 'views/components/organisms/SignUpEmailForm';
import { SignUpEmailValidateForm } from 'views/components/organisms/SignUpEmailValidateForm';

type SignUpPageLayoutProps = {
  verifiedEmail?: string;
  verifyingEmail?: string;
  presetEmail?: string;
  presetUsername?: string;
  errorMessage?: string;
  nameErrorMessage?: string;
  passwordErrorMessage?: string;
  onSendVerificationEmail(email: string): void;
  onReSendVerificationEmail(sentCallback: () => void): void;
  onValidateTransaction(code: string): void;
  onSignUp(password: string, username: string, termsAccept: boolean): void;
};

export const SignUpPageLayout: React.FC<SignUpPageLayoutProps> = ({
  verifiedEmail,
  verifyingEmail,
  presetEmail,
  presetUsername,
  errorMessage,
  nameErrorMessage,
  passwordErrorMessage,
  onSendVerificationEmail,
  onReSendVerificationEmail,
  onValidateTransaction,
  onSignUp,
}) => {
  return (
    <>
      <FormattedMessage id={localeIds.signUpPageLayout.banner}>
        {(text: string): React.ReactElement => (
          <Banner src={signUpImage} text={text} />
        )}
      </FormattedMessage>

      {verifiedEmail ? (
        <SignUpForm
          email={verifiedEmail}
          defaultUsername={presetUsername}
          errorMessage={errorMessage}
          nameErrorMessage={nameErrorMessage}
          passwordErrorMessage={passwordErrorMessage}
          onSignUp={onSignUp}
        />
      ) : verifyingEmail ? (
        <SignUpEmailValidateForm
          email={verifyingEmail}
          errorMessage={errorMessage}
          onResend={onReSendVerificationEmail}
          onPost={onValidateTransaction}
        />
      ) : (
        <SignUpEmailForm
          defaultEmail={presetEmail}
          errorMessage={errorMessage}
          onPost={onSendVerificationEmail}
        />
      )}

      <Spacer />

      <LinkText to={ROUTER_PATH.login}>
        <FormattedMessage id={localeIds.signUpPageLayout.login} />
      </LinkText>
    </>
  );
};
